// This file is used to define the functions that are used to get the data from the backend for the TrainingsHeaderView component

import axios from 'axios';
import { TRAINING_TYPE_IDS } from '../components/TrainingsHeaderView';

// Helper to check if error is an authorization error (403) or network error
// Network errors on this endpoint usually mean the authorizer denied access
const isAuthorizationError = (error: any): boolean => {
    const statusCode = error?.response?.status || error?.status;
    const isNetworkError = error?.code === 'ERR_NETWORK' || error?.message === 'Network Error';
    return statusCode === 403 || isNetworkError;
};


export type OfferingScope = {
    countries?: string;
    frontlineId?: string;
    regionId?: string;
};

const offeringScopeParams = (scope?: OfferingScope): [string, string][] => {
    if (scope?.countries) return [['offeredInCountries', scope.countries]];
    if (scope?.frontlineId) return [['offeredInFrontlineId', scope.frontlineId]];
    if (scope?.regionId) return [['offeredInRegionId', scope.regionId]];
    return [];
};

export const fetchQualificationHeadersList = async (token: string, paramsKey?: string, paramId?: number, verifiedCountryId?: string, lang?: string, businessTypeId?: number, offeringScope?: OfferingScope) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        }
        let queryparams = paramsKey ? `?${paramsKey}=${paramId}&lang=${lang}` : `?lang=${lang}`;

        if (verifiedCountryId) {
            queryparams += queryparams ? `&verifiedCountryId=${verifiedCountryId}` : `?verifiedCountryId=${verifiedCountryId}`;
        }
        if (businessTypeId) {
            queryparams += `&businessTypeId=${businessTypeId}`;
        }
        offeringScopeParams(offeringScope).forEach(([key, value]) => {
            queryparams += `&${key}=${encodeURIComponent(value)}`;
        });
        const response = await axios.get(
            `${process.env.REACT_APP_API_ENDPOINT}/v1/trainings/trainingsByView${queryparams}`,
            config,
        )
        return response.data;
    } catch (error) {
        console.error('Error fetching qualificationTypes:', error)
        // Return empty structure instead of undefined
        return {
            qualificationHeaders: [],
            titleKey: '',
            isAuthError: isAuthorizationError(error)
        };
    }
}

// TO BE REMOVED AFTER QUALIFICATIONS REVAMP
export const fetchSafteyQualificationHeadersList = async (token: string, qualificationTypeId: number, verifiedCountryId?: string, businessTypeId?: number) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        }

        const queryParams = new URLSearchParams();
        queryParams.append('qualificationTypeId', qualificationTypeId.toString());
        queryParams.append('trainingTypeId', TRAINING_TYPE_IDS.GLOBAL.toString());
        if (verifiedCountryId) {
            queryParams.append('verifiedCountryId', verifiedCountryId);
        }
        if (businessTypeId) {
            queryParams.append('businessTypeId', businessTypeId.toString());
        }

        const queryString = queryParams.toString();
        const url = `${process.env.REACT_APP_API_ENDPOINT}/v1/trainings/trainingsByView?${queryString}`;

        const response = await axios.get(url, config)
        return response.data;
    } catch (error) {
        console.error('Error fetching safety qualification headers:', error)
        return {
            qualificationHeaders: [],
            titleKey: '',
            isAuthError: isAuthorizationError(error)
        };
    }
}

// TO BE REMOVED AFTER QUALIFICATIONS REVAMP
export const fetchLocalQualificationHeadersList = async (token: string, qualificationTypeId: number, verifiedCountryId?: string, businessTypeId?: number) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        }

        const queryParams = new URLSearchParams();
        queryParams.append('qualificationTypeId', qualificationTypeId.toString());
        queryParams.append('trainingTypeId', TRAINING_TYPE_IDS.LOCAL.toString());
        if (verifiedCountryId) {
            queryParams.append('verifiedCountryId', verifiedCountryId);
        }
        if (businessTypeId) {
            queryParams.append('businessTypeId', businessTypeId.toString());
        }

        const queryString = queryParams.toString();
        const url = `${process.env.REACT_APP_API_ENDPOINT}/v1/trainings/trainingsByView?${queryString}`;

        const response = await axios.get(url, config)
        return response.data;
    } catch (error) {
        console.error('Error fetching local qualification headers:', error)
        return {
            qualificationHeaders: [],
            titleKey: '',
            isAuthError: isAuthorizationError(error)
        };
    }
}

export const fetchTrainingsHeadersList = async (token: string, qualificationTypeId: number, verifiedCountryId?: string, businessTypeId?: number, offeringScope?: OfferingScope) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        }

        const queryParams = new URLSearchParams();
        queryParams.append('qualificationTypeId', qualificationTypeId.toString());
        if (verifiedCountryId) {
            queryParams.append('verifiedCountryId', verifiedCountryId);
        }
        if (businessTypeId) {
            queryParams.append('businessTypeId', businessTypeId.toString());
        }
        offeringScopeParams(offeringScope).forEach(([key, value]) => {
            queryParams.append(key, value);
        });

        const queryString = queryParams.toString();
        const url = `${process.env.REACT_APP_API_ENDPOINT}/v1/trainings/trainingsByView?${queryString}`;

        const response = await axios.get(url, config)
        return response.data;
    } catch (error) {
        console.error('Error fetching trainings headers:', error)
        return [];
    }
}
export  const fetchRegionData = async (token: string, lang: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        }

        const response = await axios.get(

            `${process.env.REACT_APP_API_ENDPOINT}/v1/regions?lang=${lang}`,
                        config,
                    )
        return response.data;
    } catch (error) {
        console.error('Error fetching region:', error)
        return [];
    }
}


  export  const fetchFrontlineData = async (token: string,regionId: string, lang: string) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
            }
    
            const response = await axios.get(

                            `${process.env.REACT_APP_API_ENDPOINT}/v1/frontlines/${regionId}?lang=${lang}`,
                            config,
                        )
            return response.data;
        } catch (error) {
            console.error('Error fetching frontlines:', error)
            return [];
        }
    }

  export  const fetchCountryData = async (token: string,frontlineId: string, lang: string) => {

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
            }

            const response = await axios.get(

                `${process.env.REACT_APP_API_ENDPOINT}/v1/countries?frontlineId=${frontlineId}&lang=${lang}`,
                            config,
                        )
            return response.data;
        } catch (error) {
            console.error('Error fetching countries:', error)
            return [];
        }
    }

  export const fetchBusinessTypes = async (token: string, lang: string) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
            }

            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/v1/business-types?lang=${lang}`,
                config,
            )
            return response.data;
        } catch (error) {
            console.error('Error fetching business types:', error)
            return [];
        }
    }
